import React, { createContext, useState, useRef, useEffect } from "react";
import { IAccountStatusContext } from "../types/accountStatus";
import { IsAuthorized } from "../utils/helpers/auth";
import { toast } from "react-toastify";
import { accountStatusService } from "../api/accountStatusService/accountStatusService";
import { useTranslation } from "react-i18next";

export const AccountStatusContext = createContext<null | IAccountStatusContext>(null);

interface Props {
    children: React.ReactNode
}

export const AccountStatusProvider: React.FC<Props> = ({ children }) => {
    const { t } = useTranslation();

    const [isAccountBlocked, setIsAccountBlocked] = useState<boolean>(false);
    const [userHasPartialAccess, setUserHasPartialAccess] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true);

    const canGo = useRef(true);
    useEffect(() => {
        if (canGo.current === true) {
            canGo.current = false;
            if (IsAuthorized()) {
                checkAccountStatus();
            }
        }
    }, []);

    const checkAccountStatus = async () => {
        setLoading(true);
        const response = await accountStatusService.getStatus();

        if (response.success) {
            setIsAccountBlocked(response.responseBody.blocked);
            setUserHasPartialAccess(response.responseBody.partialAccess);
        } else {
            toast.error(t('errors.errorCheckingAccountStatus'));
        }

        setLoading(false);
    }


    const value: IAccountStatusContext = {
        isAccountBlocked,
        setIsAccountBlocked,
        loading,
        setLoading,
        setUserHasPartialAccess,
        userHasPartialAccess
    };

    return (
        <AccountStatusContext.Provider
            value={value}
        >
            {children}
        </AccountStatusContext.Provider>
    );
};